import { useState } from 'react';
import { AccountModel, DonViCoSo, KhachHang } from '@/types/schemas';

/**
 * Hook for managing search field selections in the search dialog
 * @returns Search field states and setters
 */
export const useSearchFieldState = () => {
  const [selectedDebitAccount, setSelectedDebitAccount] = useState<AccountModel | null>(null);
  const [selectedCustomer, setSelectedCustomer] = useState<KhachHang | null>(null);
  const [selectedCreditAccount, setSelectedCreditAccount] = useState<AccountModel | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<DonViCoSo | null>(null);

  const resetSearchFields = () => {
    setSelectedDebitAccount(null);
    setSelectedCustomer(null);
    setSelectedCreditAccount(null);
    setSelectedUnit(null);
  };

  return {
    selectedDebitAccount,
    selectedCustomer,
    selectedCreditAccount,
    selectedUnit,

    setSelectedDebitAccount,
    setSelectedCustomer,
    setSelectedCreditAccount,
    setSelectedUnit,

    resetSearchFields
  };
};
